<template>
  <div class="flow-box">
    <div class="flow-item"
      v-for="(v,i) in list" :key="i">
      <p class="icon">
        <span v-if="v.IsAudit">
          <i class="flow-icon success-icon el-icon-check" v-if="v.AuditResult == 1"></i>
          <span v-else-if="v.AuditResult == 2">
            <el-tooltip effect="dark" :content="v.AuditResultMsg" placement="top" v-if="v.AuditResultMsg">
              <i class="flow-icon danger-icon el-icon-close"></i>
            </el-tooltip>
            <i class="flow-icon danger-icon el-icon-close" v-else></i>
          </span>
        </span>
        <i class="flow-icon el-icon-more" v-else></i>
        <span style="margin-left:10px;">{{v.DeptName}}</span>
      </p>
      <p class="line-icon" v-if="i < list.length-1"></p>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    list: {
      type: Array,
      default: () =>[]
    }
  }
}
</script>
<style scoped>
.flow-box{
  display: flex;
  color: #606266;
  font-size: 14px;
}
.flow-item{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.icon{
  display: flex;
  align-items: center;
}
.flow-icon{
  width: 20px;
  height: 20px;
  background: #999;
  border-radius: 100%;
  line-height: 20px;
  text-align: center;
  color: #fff;
}
.success-icon{
  background: #67C23A;
}
.danger-icon{
  background: #F56C6C;
}
.line-icon{
  width: 45px;
  height: 2px;
  background: #999;
  margin: 0 10px;
}
</style>